/**
 * Registers the Nuvra service worker (public/sw.js), which exists solely to
 * receive Web Push. Registration is safe and idempotent: it no-ops where service
 * workers are unavailable (unsupported browser, insecure origin), and never blocks
 * boot. It does NOT add offline caching, so it cannot interfere with the live app
 * or the runtime preview.
 *
 * Actually subscribing for push (permission + PushManager) happens later, only when
 * the user opts in via the notification bell, so we never prompt for notification
 * permission on load.
 */
export function registerServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Only meaningful on a secure context (https or localhost); the browser enforces
  // this anyway, so guard to avoid a noisy console error on http.
  if (!window.isSecureContext) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* registration failure is non-fatal: push simply stays unavailable */
    });
  });
}
